import { render, staticRenderFns } from "./KasaRaporu.vue?vue&type=template&id=1852ba34&scoped=true"
import script from "./KasaRaporu.vue?vue&type=script&lang=js"
export * from "./KasaRaporu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1852ba34",
  null
  
)

export default component.exports